var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewardStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9029 11.3486C22.9322 11.1093 22.9107 10.8665 22.8398 10.6361C22.7689 10.4057 22.6502 10.1929 22.4915 10.0114C22.3308 9.82859 22.1331 9.68203 21.9114 9.58153C21.6897 9.48103 21.4492 9.4289 21.2057 9.42859H2.79432C2.55092 9.4289 2.31037 9.48103 2.08868 9.58153C1.86699 9.68203 1.66925 9.82859 1.5086 10.0114C1.34987 10.1929 1.23117 10.4057 1.16028 10.6361C1.08939 10.8665 1.06788 11.1093 1.09718 11.3486L2.38289 21.6343C2.43342 22.0524 2.63611 22.4373 2.95229 22.7156C3.26847 22.9938 3.67601 23.1459 4.09718 23.1429H19.9372C20.3583 23.1459 20.7659 22.9938 21.0821 22.7156C21.3982 22.4373 21.6009 22.0524 21.6515 21.6343L22.9029 11.3486Z",
    fill: "#F7ED90",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28564 9.42861V8.57146C4.28564 6.52551 5.0984 4.56335 6.54511 3.11664C7.99182 1.66993 9.95397 0.857178 11.9999 0.857178C14.0459 0.857178 16.008 1.66993 17.4548 3.11664C18.9015 4.56335 19.7142 6.52551 19.7142 8.57146V9.42861",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 14.5714V18",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4287 14.5714V18",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardStore);
export default __webpack_public_path__ + "static/media/reward-store.bbc78442d3fc748e0b9f2ba9ff601808.svg";
export { ForwardRef as ReactComponent };